<template>
  <div class="Container">
    <h2 class="ViewHeading">Company Detail Report</h2>
    <b-container>
      <!-- <div class="DeviceInfoTop">
    <div class="DeviceOverview"> 

                        <div class="totalBox">
                            <span class="totalText">Company Name</span> <br>
                            <span class="totalText">Company Address</span> <br>
                            <span class="totalText">Subscritpion Status</span> <br>
                            <span class="totalText">Subscritpion Rate</span> <br>
                        </div>
                       

    </div>


    <div class="PieChartDiv">
      
      <div class="chartBox">
          <Doughnut class="DoughnutChart" :chartData="this.setChartData()" :options="this.setChartOptions()" > </Doughnut>
      </div>

    </div>

</div> -->
      <div class="flex-container">
        <div class="column-left">
          <div class="totalBox">
            <div class="trustTextBox">
              <p class="trustText">{{ this.companyDetailArray.CompanyName }}</p>
              <br />
              <p class="locationText">
                {{ this.companyDetailArray.CompanyAddress }}
              </p>
              <div class="statusBox">
                <span
                  v-if="this.companyDetailArray.CompanyStatus == 'Active'"
                  class="greenDot"
                ></span>
                <span
                  v-if="this.companyDetailArray.CompanyStatus == 'Inactive'"
                  class="redDot"
                ></span>
                <p class="activeText">
                  {{ this.companyDetailArray.CompanyStatus }}
                </p>
              </div>
            </div>
            <p class="totalText">
              {{ this.companyDetailArray.CompanyContactName }}
            </p>
            <p class="totalText">
              {{ this.companyDetailArray.CompanyContactEmail }}
            </p>
            <p class="totalText">
              {{ this.companyDetailArray.CompanyContactTel }}
            </p>
          </div>
        </div>
        <div class="column-right">
          <div class="doughnutChartBox">
            <p class="chartHeader">
              Device Status for {{ this.companyDetailArray.CompanyName }}
            </p>
            <Doughnut
              class="DoughnutChart"
              :chartData="this.setChartData()"
              :options="this.setChartOptions()"
            >
            </Doughnut>
          </div>
        </div>
      </div>

      <div class="fourStateBoxesContainer">
        <div class="LowRiskDevicesBox">
          <div class="topRow"><p class="titleText">Low Risk Devices</p></div>
          <div class="bottomRow">
            <div class="leftSide">
              <p class="variableCountText">
                {{ this.companyDetailArray.LowRiskCount }}
              </p>
            </div>
            <div class="rightSide"></div>
          </div>
        </div>
        <div class="ModerateRiskDevicesBox">
          <div class="topRow">
            <p class="titleText">Moderate Risk Devices</p>
          </div>
          <div class="bottomRow">
            <div class="leftSide">
              <p class="variableCountText">
                {{ this.companyDetailArray.ModerateRiskCount }}
              </p>
            </div>
            <div class="rightSide"></div>
          </div>
        </div>
        <div class="HighRiskDevicesBox">
          <div class="topRow"><p class="titleText">High Risk Devices</p></div>
          <div class="bottomRow">
            <div class="leftSide">
              <p class="variableCountText">
                {{ this.companyDetailArray.HighRiskCount }}
              </p>
            </div>
            <div class="rightSide"></div>
          </div>
        </div>
        <div class="ExtremelyHighRiskDevicesBox">
          <div class="topRow">
            <p class="titleText">Extremely High Risk Devices</p>
          </div>
          <div class="bottomRow">
            <div class="leftSide">
              <p class="variableCountText">
                {{ this.companyDetailArray.ExtremelyHighRiskCount }}
              </p>
            </div>
            <div class="rightSide"></div>
          </div>
        </div>
      </div>

      <div class="topStackBarChart">
        <StackedBar
          class="stackedBarChart"
          :chartData="this.setStackedBarChartData()"
          :options="this.setStackedBarChartOptions()"
        >
        </StackedBar>
      </div>

      <div class="fourStateBoxesContainer">
        <div class="WMCUserCountBox">
          <span class="stateCountText">
            {{ this.companyDetailArray.WMCUserCount }} </span
          ><br /><span class="userTypeText">Water Management Users</span>
        </div>
        <div class="INSUserCountBox">
          <span class="stateCountText">
            {{ this.companyDetailArray.InstallerCount }} </span
          ><br /><span class="userTypeText">Installer Users</span>
        </div>
        <div class="CEUUserCountBox">
          <span class="stateCountText">
            {{ this.companyDetailArray.ClientUserCount }} </span
          ><br /><span class="userTypeText">Client Users</span>
        </div>
      </div>

      <div class="fourStateBoxesContainer">
        <div class="deviceStateChange">
          <h5>Most Recent Device State Changes</h5>

          <b-table
            v-if="companyLastFiveStateChange != ''"
            class="latest5Table"
            small="small"
            responsive="sm"
            borderless
            hover
            :items="companyLastFiveStateChange"
          ></b-table>
          <h5 v-if="companyLastFiveStateChange == ''">
            No Recent State Changes
          </h5>
        </div>
      </div>

      <div class="fourStateBoxesContainer">
        <div class="deviceStateChange">
          <h5>Most Recent Device Status Changes</h5>

          <b-table
            v-if="companyLastFiveStatusChange != ''"
            class="latest5Table"
            small="small"
            responsive="sm"
            borderless
            hover
            :items="companyLastFiveStatusChange"
          ></b-table>
          <h5 v-if="companyLastFiveStatusChange == ''">
            No Recent Status Changes
          </h5>
        </div>
      </div>

      <div class="fourStateBoxesContainer">
        <div class="deviceStateChange">
          <h5>Most Recent Support Requests</h5>

          <b-table
            v-if="companyLastFiveSupportRequests != ''"
            class="latest5Table"
            small="small"
            responsive="sm"
            borderless
            hover
            :items="companyLastFiveSupportRequests"
          ></b-table>
          <h5 v-if="companyLastFiveSupportRequests == ''">
            No Recent Support Requests
          </h5>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  components: {},

  data() {
    return {
      perPage: 10,
      currentPage: 1,
      AlarmItems: [],
      UserHeaders: [],
      ArrTest: [],
      ErrorHeaders: [],
      ErrorItems: [],
      SupportItems: [],
      SupportHeaders: [],
      ServiceItems: [],
      ServiceHeaders: [],
      location: "",
      locations: [],
      filteredlocations: [],
      modal: false,
      GreenCount: "--",
      AmberCount: "--",
      RedCount: "--",
      responseArray: [],
      responselist: [],
      CompanyName: this.$Company,
      GoodState: "",
      ExcellentState: "",
      BadState: "",
      FairState: "",
      locationsArray: [],
      locationsList: [],
      deviceLocation: "",
      hover: false,
      TodayDate: "",
      TotalDevices: "",
      time: "",
      value: "1000",
      max: "1000",
      DeviceMessage: "",
      resetButtonDisable: false,
      submitButtonDisable: false,
      companyDetailArray: [],
      companyLocationsDevicesDetails: [],
      companyLocationStackLabels: [],
      companyLastFiveStateChange: [],
      companyLastFiveStatusChange: [],
      companyLastFiveSupportRequests: [],
      companyLastFiveDeviceOrders: [],
    };
  },

  async mounted() {
    this.CompanyLocation = localStorage.getItem("CompanyReportLocation");
    localStorage.removeItem("CompanyReportLocation");

    let LookUpURL =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/sudashboard";
    let LookUpHeaders = this.$apikeyPost;
    let LookUpData = {
      RequestType: "",
      Report: "CompanyDetail",
      RequestVariable: this.CompanyLocation,
    };
    axios.post(LookUpURL, LookUpData, LookUpHeaders).then((response) => {
      this.companyLocationsDevicesDetails = response.data.LocationData[1];
      this.companyLocationStackLabels = response.data.LocationData[0];
      this.companyLastFiveStateChange = response.data.FiveStateChanges;
      this.companyLastFiveStatusChange = response.data.FiveStatusChanges;
      this.companyLastFiveSupportRequests = response.data.MostRecentSupport;
      this.companyDetailArray = response.data.Values[0];
    });

    let LookUpUrl3 =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeaders3 = this.$apikeyPost;
    this.LookUpRequest3 = {
      RequestType: "Location",
      Company: this.CompanyLocation,
    };
    axios
      .post(LookUpUrl3, this.LookUpRequest3, LookUpHeaders3)
      .then((response) => {
        this.locationslist = response.data.Values;
        for (let i = 0; i < this.locationslist.length; i++) {
          var QuoteStr4 = this.locationslist[i][0];
          this.locationsArray.push({
            id: QuoteStr4,
            location: this.locationslist[i][2],
            address: this.locationslist[i][1],
          });
        }
      });
  },

  methods: {
    resetValue: function() {
      this.resetButtonDisable = true;
      (this.responseArray = []), (this.responselist = []);
      this.locations = [];
      (this.deviceLocation = ""), (this.location = "");
      this.modal = false;
      let LookUpURL =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/dashboard";
      let LookUpHeaders = this.$apikeyPost;
      let LookUpData = {
        RequestType: "Company",
        Report: "DeviceReport",
        RequestVariable: "",
        Company: this.CompanyName,
      };
      axios.post(LookUpURL, LookUpData, LookUpHeaders).then((response) => {
        setTimeout(() => (this.resetButtonDisable = false), 1000);

        this.responselist = response.data.Values;
        /* let current = new Date();
      this.TodayDate = current.getFullYear()+','+(current.getMonth()+1)+','+current.getDate()+','+current.getHours()+','+current.getMinutes()+','+current.getSeconds(); */
        for (let i = 0; i < this.responselist.length; i++) {
          var QuoteStr = this.responselist[i][0];
          var FlowTime = "";
          var FlowDate = "";
          var FlowTimeDate = "";
          var BioFilmLvl = "";

          BioFilmLvl = this.responselist[i][10];
          FlowDate = this.responselist[i][8];
          FlowTime = this.responselist[i][9];
          if (FlowDate != "N/A") {
            FlowTimeDate = FlowDate + FlowTime;
            let d1 = Date.now();
            let d2 = new Date(FlowTimeDate).getTime();
            this.time = Math.floor((d1 - d2) / 1000 / 60 / 60);
          } else if (FlowDate === "N/A") {
            this.time = "N/A";
          }

          if (BioFilmLvl == "N/A") {
            BioFilmLvl = "NoBio";
          }

          this.responseArray.push({
            DeviceID: QuoteStr,
            BuildingName: this.responselist[i][1],
            Position: this.responselist[i][2],
            Feed: this.responselist[i][3],
            Score: this.responselist[i][4],
            TempHi: this.responselist[i][5],
            TempLo: this.responselist[i][6],
            TempMed: this.responselist[i][7],
            FlowRead: this.time,
            PathogenRead: BioFilmLvl,
          });
          /* this.chartData.push({Label:"Value", Risk:this.responselist[i][3]}) */
        }
        this.DeviceMessage = "Total Devices for " + this.CompanyName;
      });

      let LookUpURL2 =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/statuscounts";
      let LookUpHeaders2 = this.$apikeyPost;
      let LookUpData2 = {
        RequestType: "Company",
        RequestVariable: this.CompanyName,
      };

      axios.post(LookUpURL2, LookUpData2, LookUpHeaders2).then((response) => {
        this.BadState = response.data.Bad[0];
        this.FairState = response.data.Fair[0];
        this.GoodState = response.data.Good[0];
        this.ExcellentState = response.data.Excellent[0];
        this.TotalDevices = response.data.Total[0];
      });
    },

    LookUpState: function(State) {
      if (this.deviceLocation != "") {
        (this.responseArray = []), (this.responselist = []);
        let StateType = State;
        let LookUpURLState =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/dashboard";
        let LookUpHeadersState = this.$apikeyPost;
        let LookUpDataState = {
          RequestType: "StateLocation",
          Report: "DeviceReport",
          RequestVariable: StateType,
          Company: this.CompanyName,
          Location: this.deviceLocation.text,
        };

        axios
          .post(LookUpURLState, LookUpDataState, LookUpHeadersState)
          .then((response) => {
            this.responselist = response.data.Values;
            /* let current = new Date();
      this.TodayDate = current.getFullYear()+','+(current.getMonth()+1)+','+current.getDate()+','+current.getHours()+','+current.getMinutes()+','+current.getSeconds(); */
            for (let i = 0; i < this.responselist.length; i++) {
              var QuoteStr = this.responselist[i][0];
              var FlowTime = "";
              var FlowDate = "";
              var FlowTimeDate = "";
              var BioFilmLvl = "";

              BioFilmLvl = this.responselist[i][10];
              FlowDate = this.responselist[i][8];
              FlowTime = this.responselist[i][9];
              if (FlowDate != "N/A") {
                FlowTimeDate = FlowDate + FlowTime;
                let d1 = Date.now();
                let d2 = new Date(FlowTimeDate).getTime();
                this.time = Math.floor((d1 - d2) / 1000 / 60 / 60);
              } else if (FlowDate === "N/A") {
                this.time = "N/A";
              }

              if (BioFilmLvl == "N/A") {
                BioFilmLvl = "NoBio";
              }

              this.responseArray.push({
                DeviceID: QuoteStr,
                BuildingName: this.responselist[i][1],
                Position: this.responselist[i][2],
                Feed: this.responselist[i][3],
                Score: this.responselist[i][4],
                TempHi: this.responselist[i][5],
                TempLo: this.responselist[i][6],
                TempMed: this.responselist[i][7],
                FlowRead: this.time,
                PathogenRead: BioFilmLvl,
              });
              /* this.chartData.push({Label:"Value", Risk:this.responselist[i][3]}) */
            }

            var StateWord = "";

            if (StateType == 4) {
              StateWord = "Low Risk";
              this.TotalDevices = this.ExcellentState;
            }
            if (StateType == 3) {
              StateWord = "Moderate Risk";
              this.TotalDevices = this.GoodState;
            }
            if (StateType == 2) {
              StateWord = "High Risk";
              this.TotalDevices = this.FairState;
            }
            if (StateType == 1) {
              StateWord = "Extremely High Risk";
              this.TotalDevices = this.BadState;
            }

            this.DeviceMessage =
              "Total Devices in " +
              StateWord +
              " State in " +
              this.deviceLocation.text;
          });
      } else {
        (this.responseArray = []), (this.responselist = []);

        let StateType = State;

        let LookUpURLState =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/dashboard";
        let LookUpHeadersState = this.$apikeyPost;
        let LookUpDataState = {
          RequestType: "State",
          Report: "DeviceReport",
          RequestVariable: StateType,
          Company: this.CompanyName,
        };

        axios
          .post(LookUpURLState, LookUpDataState, LookUpHeadersState)
          .then((response) => {
            this.responselist = response.data.Values;
            /* let current = new Date();
      this.TodayDate = current.getFullYear()+','+(current.getMonth()+1)+','+current.getDate()+','+current.getHours()+','+current.getMinutes()+','+current.getSeconds(); */
            for (let i = 0; i < this.responselist.length; i++) {
              var QuoteStr = this.responselist[i][0];
              var FlowTime = "";
              var FlowDate = "";
              var FlowTimeDate = "";
              var BioFilmLvl = "";

              BioFilmLvl = this.responselist[i][10];
              FlowDate = this.responselist[i][8];
              FlowTime = this.responselist[i][9];
              if (FlowDate != "N/A") {
                FlowTimeDate = FlowDate + FlowTime;
                let d1 = Date.now();
                let d2 = new Date(FlowTimeDate).getTime();
                this.time = Math.floor((d1 - d2) / 1000 / 60 / 60);
              } else if (FlowDate === "N/A") {
                this.time = "N/A";
              }

              if (BioFilmLvl == "N/A") {
                BioFilmLvl = "NoBio";
              }

              this.responseArray.push({
                DeviceID: QuoteStr,
                BuildingName: this.responselist[i][1],
                Position: this.responselist[i][2],
                Feed: this.responselist[i][3],
                Score: this.responselist[i][4],
                TempHi: this.responselist[i][5],
                TempLo: this.responselist[i][6],
                TempMed: this.responselist[i][7],
                FlowRead: this.time,
                PathogenRead: BioFilmLvl,
              });
              /* this.chartData.push({Label:"Value", Risk:this.responselist[i][3]}) */
            }
            var StateWord = "";

            if (StateType == 4) {
              StateWord = "Low Risk";
              this.TotalDevices = this.ExcellentState;
            }
            if (StateType == 3) {
              StateWord = "Moderate Risk";
              this.TotalDevices = this.GoodState;
            }
            if (StateType == 2) {
              StateWord = "High Risk";
              this.TotalDevices = this.FairState;
            }
            if (StateType == 1) {
              StateWord = "Extremely High Risk";
              this.TotalDevices = this.BadState;
            }

            this.DeviceMessage =
              "Total Devices in " +
              StateWord +
              " State for " +
              this.CompanyName;
          });
      }
    },

    submitLocation() {
      if (this.deviceLocation != "") {
        this.submitButtonDisable = true;

        (this.responseArray = []),
          (this.responselist = []),
          (this.BadState = "");
        this.FairState = "";
        this.GoodState = "";
        this.ExcellentState = "";
        this.TotalDevices = "";
        let LookUpURLLocation =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/dashboard";
        let LookUpHeadersLocation = this.$apikeyPost;
        let LookUpDataLocation = {
          RequestType: "Location",
          Report: "DeviceReport",
          RequestVariable: this.deviceLocation.text,
          Company: this.CompanyName,
        };
        axios
          .post(LookUpURLLocation, LookUpDataLocation, LookUpHeadersLocation)
          .then((response) => {
            this.responselist = response.data.Values;
            /* let current = new Date();
      this.TodayDate = current.getFullYear()+','+(current.getMonth()+1)+','+current.getDate()+','+current.getHours()+','+current.getMinutes()+','+current.getSeconds(); */
            for (let i = 0; i < this.responselist.length; i++) {
              var QuoteStr = this.responselist[i][0];
              var FlowTime = "";
              var FlowDate = "";
              var FlowTimeDate = "";
              var BioFilmLvl = "";

              BioFilmLvl = this.responselist[i][10];
              FlowDate = this.responselist[i][8];
              FlowTime = this.responselist[i][9];
              if (FlowDate != "N/A") {
                FlowTimeDate = FlowDate + FlowTime;
                let d1 = Date.now();
                let d2 = new Date(FlowTimeDate).getTime();
                this.time = Math.floor((d1 - d2) / 1000 / 60 / 60);
              } else if (FlowDate === "N/A") {
                this.time = "N/A";
              }

              if (BioFilmLvl == "N/A") {
                BioFilmLvl = "NoBio";
              }
              this.responseArray.push({
                DeviceID: QuoteStr,
                BuildingName: this.responselist[i][1],
                Position: this.responselist[i][2],
                Feed: this.responselist[i][3],
                Score: this.responselist[i][4],
                TempHi: this.responselist[i][5],
                TempLo: this.responselist[i][6],
                TempMed: this.responselist[i][7],
                FlowRead: this.time,
                PathogenRead: BioFilmLvl,
              });
              /* this.chartData.push({Label:"Value", Risk:this.responselist[i][3]}) */
            }

            this.DeviceMessage = "Total Devices in " + this.deviceLocation.text;
            setTimeout(() => (this.submitButtonDisable = false), 1000);
          });
        let LookUpURL2 =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/statuscounts";
        let LookUpHeaders2 = this.$apikeyPost;
        let LookUpData2 = {
          RequestType: "Location",
          RequestVariable: this.deviceLocation.text,
          Company: this.CompanyName,
        };

        axios.post(LookUpURL2, LookUpData2, LookUpHeaders2).then((response) => {
          this.BadState = response.data.Bad[0];
          this.FairState = response.data.Fair[0];
          this.GoodState = response.data.Good[0];
          this.ExcellentState = response.data.Excellent[0];
          this.TotalDevices = response.data.Total[0];
        });
      } else {
        alert("Please select a location to further filter the data");
      }
    },

    DeviceReportGen: function(id, Location, Position) {
      localStorage.setItem("PassID", id);
      localStorage.setItem("DevLocation", Location);
      localStorage.setItem("DevPosition", Position);
      this.$router.push("/DeviceReport");
    },

    setLocation(location) {
      this.location = location;
      this.modal = false;
    },
    setChartData() {
      return {
        labels: ["Active", "Inactive", "Suspended", "Terminated", "New"],
        datasets: [
          {
            borderWidth: 0,

            backgroundColor: [
              "#28a745",
              "#4986A6",
              "#6D6059",
              "rgb(25,25,25)",
              "rgb(230,230,230)",
            ],

            data: [
              this.companyDetailArray.ActiveCount,
              this.companyDetailArray.InactiveCount,
              this.companyDetailArray.SuspendedCount,
              this.companyDetailArray.TerminatedCount,
              this.companyDetailArray.NewCount,
            ],
          },
        ],
      };
    },
    setChartOptions() {
      return {
        legend: {
          display: true,
          position: "right",
        },
        cutoutPercentage: 60,
        borderAlign: "center",

        title: {
          display: false,
          text: "Devices",
        },
        responsive: true,
        maintainAspectRatio: false,
      };
    },

    setStackedBarChartData() {
      return {
        labels: this.companyLocationStackLabels,
        datasets: this.companyLocationsDevicesDetails,
      };
    },
    setStackedBarChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: "Device Risk Levels in Locations",
        },
        scales: {
          xAxes: [
            {
              stacked: true,
            },
          ],
          yAxes: [
            {
              stacked: true,
              ticks: {
                precision: 0,
              },
            },
          ],
        },
        legend: {
          display: true,
          position: "bottom",
        },
      };
    },
  },

  watch: {},
};
</script>

<style scoped>
@import "../../node_modules/bootstrap-slider/dist/css/bootstrap-slider.css";

input[type="text"],
select {
  padding: 7px 7px 7px 7px;

  border: solid 1px rgba(200, 200, 200, 0.5);

  border-radius: 25px;

  background-color: rgb(245, 245, 245);
}

.Grid > div {
  border: 1px solid black;
  border-radius: 5px;
  background-color: white;
  width: 100%;
}

.Grid {
  margin-top: 10px;
}

h4 {
  text-align: center;
}

.card-text {
  text-align: center;
}

.Auto {
  padding-left: 15px;
}

#UnitRAG {
  padding-top: 5px;
  margin-top: 5px;
}
.GraphContainer {
  width: 100%;
  padding-top: 10px;
}

.Graphs {
  width: 33.3%;
  float: left;
  border: solid 1px black;
  min-height: 16rem;
  color: black;
  background-color: rgb(236, 239, 245);
}

.TitleRow {
  padding: 0;
}

.centre {
  text-align: center;
}

.bottomLeft {
  width: 33.3%;
  border-right: solid 1px rgb(180, 180, 180);
  border-top: solid 1px rgb(180, 180, 180);
  padding-top: 10px;
  padding-bottom: 5px;
}

.row {
  margin: 0;
}

.bottomRight {
  width: 33.3%;
  border-top: solid 1px rgb(180, 180, 180);
  padding-top: 10px;
  padding-bottom: 5px;
}

.topLeft {
  width: 100%;
  padding-bottom: 10px;
}

.Icon {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 47.5%;
}

.GaugeText {
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  text-decoration: underline;
  font-weight: bold;
  padding-top: 10px;
}

.HeadingGaugeText {
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  margin-top: 5px;
}

.Gauge {
  text-align: center;
  display: flex;
  justify-content: center;
}
#leftRow {
  margin: 0;
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
}
.TempText {
  text-align: center;
  width: 100%;
}
.HeaderText,
.GaugeText {
  text-align: center;
  width: 100%;
  font-weight: 600;
  display: flex;
  justify-content: center;
  color: black;
}

h5 {
  font-size: 0.95rem;
  padding-top: 5px;
  padding-bottom: 5px;
  width: 100%;
}

#TempCol {
  text-align: center;
  margin-bottom: 5px;
}

#TempColMid {
  text-align: center;
  margin-bottom: 5px;
  margin-left: 5px;
  margin-right: 5px;
}

.centre,
.TempText {
  font-size: 0.7rem;
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  color: #000;
}

.Gauge {
  padding-top: 5px;
}

.SearchFilters {
  padding-top: 30px;
}
#ScoreBar {
  height: 100%;
  width: 85%;
  margin: 0 auto;
  padding-top: 5%;
  padding-bottom: 5%;
}

#OverallScoreContainer {
  position: relative;
  border: solid 1px black;
}
#ScoreSlider {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 409;
  width: 100%;
}

.progress {
  border-radius: 0px;
}

.dashCol {
  background-color: rgb(240, 248, 255);
  border: solid 1px rgb(180, 180, 180);
  border-radius: 25px;
}
.lowRiskHeader {
  text-align: center;
  width: 100%;

  background-color: #28a745;
  height: 4rem;
  border: 0px;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
}
.modRiskHeader {
  text-align: center;
  width: 100%;

  background-color: rgb(252, 252, 38);
  height: 4rem;
  border: 0px;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
}
.highRiskHeader {
  text-align: center;
  width: 100%;

  background-color: #ffc107;
  height: 4rem;
  border: 0px;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
}
.extHighRiskHeader {
  text-align: center;
  width: 100%;

  background-color: #dc3545;
  height: 4rem;
  border: 0px;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
}
.dashRow {
  display: flex;
  background-color: #ff000000;
  padding: 0.5rem;
}
.dashText {
  color: rgb(14, 14, 14);
}
.riskText {
  padding: 0 !important;
  margin: 0 !important;
  text-align: center;
  font-size: 0.8rem;
  font-weight: bold;
  color: rgb(14, 14, 14);
}
.dashDeviceText {
  font-size: 1.1rem;
  padding-top: 0.1rem;
}
.dashHeaderText {
  font-size: 0.8rem;
  padding-bottom: 0.2rem;
}

.col {
  padding-left: 7px;
  padding-right: 7px;
}

#Selector {
  text-align: center;
  width: 100%;
  padding: 0;
  margin: 0;
}

.pageHeader {
  text-align: center;

  padding-top: 1rem;
  padding-bottom: 1rem;
  margin-left: 3rem;
  margin-right: 3rem;
}

#ButtonRow {
  padding-bottom: 1.5rem;
  border-bottom: solid 2px rgb(220, 220, 220);
  margin-left: 3rem;
  margin-right: 3rem;
}

.DeviceStatusText {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.LocationSearch {
  margin-right: 1.25rem;
}

label {
  margin: 0;
}

.DeviceOverview {
  width: 48%;
  float: left;
  color: black;
  margin-right: 2%;
  flex: 1;
}

.PieChartDiv {
  width: 50%;
  float: right;
}

.DeviceInfoTop {
  display: flex;
  width: 100%;
  overflow: hidden;
  flex: 1;
}
.chartBox {
  height: 95%;
  margin: 1rem 1rem 0rem 1rem;
  text-align: left;
  background-color: #eeeeee;
  border: 0;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.DoughnutChart {
  margin-left: auto;
  margin-right: auto;
  padding-top: 10px;
  padding-bottom: 10px;
  height: 225px;
}
.topStackBarChart {
  margin-left: 3rem;
  margin-right: 3rem;
  overflow: hidden;
  background-color: #eeeeee;
  border-radius: 25px;
  margin-top: 3rem;
  margin-bottom: 2rem;
}

.stackedBarChart {
  position: relative;
  margin-right: 2rem;
  margin-left: 2rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

/* Updates 240122  */

.totalText {
  margin: 0;
  padding: 0;
  width: 100%;
  text-align: left;
  padding-left: 1.5rem;
  font-size: 1rem;
  margin-top: 0.5rem;
}

.textAlignLeft {
  margin: 0;
  padding: 0;
  font-size: 1rem;
  text-align: left;
  width: 50%;
  float: left;
  padding-left: 1.5rem;
}
.textAlignRight {
  margin: 0;
  padding: 0;
  font-size: 1rem;
  font-size: 1rem;
  text-align: right;
  width: 50%;
  float: right;
  padding-right: 1.5rem;
}
.rightCountBox {
  float: right;
  width: 48%;
}
.leftCountBox {
  float: left;
  width: 48%;
}
.totalBox {
  text-align: center;
  width: 100%;
  background-color: #eeeeee;
  border: 0px;
  border-radius: 15px;
  margin-left: 2rem;
  margin-right: 2rem;
  color: black;
}

.doughnutChartBox {
  text-align: center;
  width: 100%;
  background-color: #eeeeee;
  border: 0px;
  border-radius: 15px;
  color: black;
}
.stateCountText {
  font-size: 3rem;
  padding: 0 !important;
  text-align: left;
}

.lowRiskCount {
  margin: 1rem 1rem 0rem 1rem;
  padding: 0rem 1.5rem 0.5rem 1.5rem;
  text-align: left;
  width: 100%;
  background-color: #eeeeee;
  border: 0px;
  border-radius: 15px;
}
.modRiskCount {
  margin: 1rem 1rem 0rem 1rem;
  padding: 0rem 1.5rem 0.5rem 1.5rem;
  text-align: left;
  width: 100%;
  background-color: #eeeeee;
  border: 0px;
  border-radius: 15px;
}
.highRiskCount {
  margin: 1rem 1rem 0rem 1rem;
  padding: 0rem 1.5rem 0.5rem 1.5rem;
  text-align: left;
  width: 100%;
  background-color: #eeeeee;
  border: 0px;
  border-radius: 15px;
}
.extHighRiskCount {
  margin: 1rem 1rem 0rem 1rem;
  text-align: left;
  padding: 0rem 1.5rem 0.5rem 1.5rem;
  width: 100%;
  background-color: #eeeeee;
  border: 0px;
  border-radius: 15px;
}

.flex-container {
  padding-left: 3rem;
  padding-right: 3rem;
  width: 100%;
  margin: 0 auto;
  display: -webkit-flex; /* Safari */
  display: flex; /* Standard syntax */
}
.flex-container .column-left,
.column-right {
  -webkit-flex: 1; /* Safari */
  -ms-flex: 1; /* IE 10 */
  flex: 1; /* Standard syntax */
}
.column-left {
  text-align: center;
  width: 100%;
  border: 0px;
  color: black;
  justify-content: center;
  align-items: center;
  display: flex;
  background-color: #eeeeee;
  margin-right: 1rem;
  border-radius: 25px;
}

.column-right {
  background-color: #eeeeee;
  width: 100%;
  margin-left: 1rem;
  border-radius: 25px;
  justify-content: center;
  align-items: center;
  display: flex;
}

.trustTextBox {
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  padding: 0.5rem 1rem 1rem 1.5rem;
  text-align: left;
  border-bottom: solid 1px rgb(220, 220, 220);
}
.trustText {
  margin: 0 !important;
  font-size: 1rem;
  font-weight: 600;
  display: inline;
}
.locationText {
  display: inline;
}

.chartHeader {
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
}

.greenDot {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  float: right;
  box-shadow: 0 0 8px #28a745, inset 0 0 8px #28a745;
  background-color: #28a745;
}
.redDot {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  float: right;
  box-shadow: 0 0 8px #dc3545, inset 0 0 8px #dc3545;
  background-color: #dc3545;
}

.activeText {
  color: #a3a3a3;
  display: inline;
  font-size: 0.9rem;
  font-weight: 600;
  float: right;
  margin: 0 !important;
  padding-right: 1rem;
}
.statusBox {
  float: right;
}

/* FOUR STATE BUTTONS CSS */

.fourStateBoxesContainer {
  /*
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  overflow: hidden;
  padding-left: 3rem;
  padding-right: 3rem;
  text-align: center;
  margin: 0 auto;
  margin-top: 2rem; */

  padding-left: 3rem;
  padding-right: 3rem;
  width: 100%;
  margin: 0 auto;
  display: -webkit-flex; /* Safari */
  display: flex; /* Standard syntax */
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.LowRiskDevicesBox {
  width: 25%;
  float: left;
  margin-right: 1rem;
  background-color: #eeeeee;
  border-radius: 15px;
}

.ModerateRiskDevicesBox {
  width: 25%;
  float: left;
  background-color: #eeeeee;
  margin-right: 0.5rem;
  border-radius: 15px;
}
.HighRiskDevicesBox {
  width: 25%;
  float: left;
  background-color: #eeeeee;
  margin-left: 0.5rem;
  border-radius: 15px;
}

.ExtremelyHighRiskDevicesBox {
  width: 25%;
  float: right;
  background-color: #eeeeee;
  margin-left: 1rem;
  border-radius: 15px;
}

.titleText {
  text-align: left;
  margin: 0;
  padding: 0;
  width: 100%;
  font-size: 0.9rem;
  padding-top: 0.5rem;
  padding-left: 1rem;
  color: black !important;
}

.variableCountText {
  text-align: left;
  padding-top: 0.33rem;
  padding-left: 1rem;
  font-size: 2.5rem;
  color: black !important;
  display: inline;
}

.stateCountChangeText {
  text-align: right;
  padding-right: 1rem;
  padding-top: 1rem;
  padding-bottom: 0 !important;
  color: black;
  display: inline;
  float: right;
}

.leftSide {
  width: 50%;
  float: left;
}

.rightSide {
  width: 50%;
  float: right;
}

.bottomRow {
  width: 100%;
  margin: 0 auto;
  display: -webkit-flex; /* Safari */
  display: flex; /* Standard syntax */
  -webkit-flex: 1; /* Safari */
  -ms-flex: 1; /* IE 10 */
  flex: 1; /* Standard syntax */
}

.WMCUserCountBox,
.INSUserCountBox,
.CEUUserCountBox {
  text-align: center;
  border-radius: 15px;
  background-color: #eeeeee;
  color: black;
  padding-bottom: 0.5rem;
}

.WMCUserCountBox {
  width: 33%;
  float: left;
  margin-right: 1rem;
}
.INSUserCountBox {
  width: 33%;
  float: left;
}
.CEUUserCountBox {
  width: 33%;
  float: right;
  margin-left: 1rem;
}

.deviceStateChange {
  width: 100%;
  text-align: center;
  border-radius: 25px;
  background-color: #eeeeee;
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

/*
.deviceStateChangeTableColumn{
  float: left;
  width: 16.6%;
  display: inline;
  position:static
}
*/
.rowFiveStateChange p {
  margin: 0;
}
</style>
